export default "__VITE_ASSET__DJy6NKCk__"